import angular from 'angular'
import searchService from './search'
import authorService from './author'
import siteService from './site'
import storyService from '~/modules/services/story/index'
import toolboxService from './toolbox'
import usersService from './users'
import searchFiltersService from './searchFilters'
import settingsService from './settings'
import contentTemplatesService from './contentTemplates'
import storyTemplateService from './storyTemplate'
import metaTemplatesService from './metaTemplates'
import hydrateService from './hydrate'
import globalStoreService from './globalStore'
import thirdPartyIntegrationService from './thirdPartyIntegration'
import padlockService from './padlock'
import planningStoreService from './planningStore'
import revisionHistoryService from './revisionHistory'
import store from './store'
import publishService from './publish'
import tagsService from './tags'
import webskedService from './websked'
import picklistService from './picklists'
import tabService from './tabs'
import fnService from './fn'
import contentApiService from './contentApiService'
import ansService from './ans'
import monitoringService from './monitoring'
import pharosService from './pharos'
import httpInterceptorService from './httpInterceptor'
import findReplaceService from './findReplace'
import afterNextClickService from './afterNextClick'
import hyperlinkService from './hyperlink'
import lazyWatcherService from './lazyWatcher'
import caretService from './caret'
import getErrorMessageService from './getErrorMessage'
import featureFlagService from './featureFlag'
import toastService from './toastService'
import evidently from './evidently'

export default angular
  .module('ellipsis.services', [])
  .service('authorService', authorService)
  .service('contentTemplatesService', contentTemplatesService)
  .service('globalStoreService', globalStoreService)
  .service('hydrateService', hydrateService)
  .service('metaTemplatesService', metaTemplatesService)
  .service('storyTemplateService', storyTemplateService)
  .service('searchFiltersService', searchFiltersService)
  .service('searchService', searchService)
  .service('settingsService', settingsService)
  .service('siteService', siteService)
  .service('storyService', storyService)
  .service('thirdPartyIntegrationService', thirdPartyIntegrationService)
  .service('toolboxService', toolboxService)
  .service('usersService', usersService)
  .service('padlockService', padlockService)
  .service('planningStoreService', planningStoreService)
  .service('revisionHistoryService', revisionHistoryService)
  .service('storeService', store)
  .service('publishService', publishService)
  .service('tagsService', tagsService)
  .service('webskedService', webskedService)
  .service('picklistService', picklistService)
  .service('tabService', tabService)
  .service('fnService', fnService)
  .service('contentApiService', contentApiService)
  .service('ansService', ansService)
  .service('monitoringService', monitoringService)
  .service('pharosService', pharosService)
  .service('httpInterceptorService', httpInterceptorService)
  .service('findReplaceService', findReplaceService)
  .service('findReplaceService', findReplaceService)
  .service('afterNextClickService', afterNextClickService)
  .service('hyperlinkService', hyperlinkService)
  .service('lazyWatcherService', lazyWatcherService)
  .service('caretService', caretService)
  .service('getErrorMessage', getErrorMessageService)
  .service('featureFlagService', featureFlagService)
  .service('toastService', toastService)
  .service('evidentlyService', evidently)
